(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    class CollectionFilterSheet extends HTMLElement {
    connectedCallback() {
      this.backdrop = this.querySelector('[data-filters-backdrop]');
      this.closeBtn = this.querySelector('[data-filters-close]');
      this.openBtn = document.querySelector('[data-filters-open]');

      this.openBtn && this.openBtn.addEventListener('click', () => this.open());
      this.closeBtn && this.closeBtn.addEventListener('click', () => this.close());
      this.backdrop && this.backdrop.addEventListener('click', () => this.close());
    }

    open() {
      this.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
  }

  if (!customElements.get('collection-filter-sheet')) {
    customElements.define('collection-filter-sheet', CollectionFilterSheet);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["enquiry-popup"] && !Shopify.designMode) return;
  try {
    class EnquiryDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-enquiry-dialog]');
      this.openBtn = this.querySelector('[data-enquiry-open]');
      this.closeBtn = this.querySelector('[data-enquiry-close]');
      this.form = this.querySelector('form');
      this.errorEl = this.querySelector('[data-enquiry-error]');
      this.submitBtn = this.querySelector('.enquiry__submit');
      this.successEl = this.querySelector('[data-enquiry-success]');
      this.successTextEl = this.querySelector('[data-enquiry-success-text]');
      this.fieldsEl = this.querySelector('[data-enquiry-fields]');
      this.successCloseTimer = null;
      this.minLoadingMs = 2000;

      if (!this.dialog) return;

      this.openBtn && this.openBtn.addEventListener('click', () => {
        this.resetPanel();
        this.dialog.showModal();
      });
      this.closeBtn && this.closeBtn.addEventListener('click', () => this.closeDialogAnimated());

      let backdropMouseDown = false;
      this.dialog.addEventListener('mousedown', (event) => {
        backdropMouseDown = event.target === this.dialog;
      });
      this.dialog.addEventListener('click', (event) => {
        if (backdropMouseDown && event.target === this.dialog) this.closeDialogAnimated();
        backdropMouseDown = false;
      });
      this.dialog.addEventListener('close', () => {
        if (this.successCloseTimer) {
          clearTimeout(this.successCloseTimer);
          this.successCloseTimer = null;
        }
        this.submitBtn && (this.submitBtn.disabled = false);
      });

      this.form && this.form.addEventListener('submit', (event) => this.handleSubmit(event));

      const successSource = this.querySelector('[data-auto-dismiss]');
      const navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      const isReload = navEntry ? navEntry.type === 'reload' : false;
      if (successSource && !isReload) {
        this.resetPanel();
        this.dialog.showModal();
        this.showLoading();
        requestAnimationFrame(() => this.showSuccess(successSource.textContent));
      }
    }

    resetPanel() {
      if (this.successCloseTimer) {
        clearTimeout(this.successCloseTimer);
        this.successCloseTimer = null;
      }
      this.form && this.form.reset();
      this.errorEl && (this.errorEl.hidden = true);
      this.fieldsEl && (this.fieldsEl.hidden = false);
      if (this.submitBtn) {
        this.submitBtn.hidden = false;
        this.submitBtn.disabled = false;
      }
      if (this.successEl) {
        this.successEl.classList.remove('is-sent');
        this.successEl.hidden = true;
      }
    }

    async handleSubmit(event) {
      event.preventDefault();
      const formData = new FormData(this.form);
      this.submitBtn && (this.submitBtn.disabled = true);
      this.showLoading();
      const loadingStartedAt = Date.now();

      let response;
      try {
        response = await fetch(this.form.action, { method: 'POST', body: formData });
      } catch (error) {
        this.form.submit();
        return;
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const success = doc.querySelector('[data-auto-dismiss]');
      const remaining = Math.max(0, this.minLoadingMs - (Date.now() - loadingStartedAt));

      if (success) {
        this.errorEl && (this.errorEl.hidden = true);
        this.form.reset();
        setTimeout(() => this.showSuccess(success.textContent), remaining);
      } else {
        setTimeout(() => {
          this.hideLoading();
          this.submitBtn && (this.submitBtn.disabled = false);
          const message = doc.querySelector('[data-enquiry-error]');
          if (this.errorEl) {
            this.errorEl.textContent = message && message.textContent.trim()
              ? message.textContent
              : 'Something went wrong. Please try again.';
            this.errorEl.hidden = false;
          }
        }, remaining);
      }
    }

    showLoading() {
      if (!this.successEl) return;
      this.fieldsEl && (this.fieldsEl.hidden = true);
      this.submitBtn && (this.submitBtn.hidden = true);
      this.successEl.classList.remove('is-sent');
      this.successEl.hidden = false;
      if (this.successTextEl) this.successTextEl.textContent = 'Sending your message…';
    }

    hideLoading() {
      if (!this.successEl) return;
      this.successEl.classList.remove('is-sent');
      this.successEl.hidden = true;
      this.fieldsEl && (this.fieldsEl.hidden = false);
      this.submitBtn && (this.submitBtn.hidden = false);
    }

    showSuccess(message) {
      if (!this.successEl) {
        this.closeDialogAnimated();
        return;
      }

      if (this.successTextEl) this.successTextEl.textContent = message;
      this.successEl.classList.add('is-sent');

      this.successCloseTimer = setTimeout(() => {
        this.successCloseTimer = null;
        this.closeDialogAnimated();
      }, 2000);
    }

    closeDialogAnimated(after) {
      if (!this.dialog.open) return;
      const panel = this.dialog.querySelector('.enquiry__panel');
      const onEnd = () => {
        panel.removeEventListener('transitionend', onEnd);
        this.dialog.classList.remove('is-closing');
        this.dialog.close();
        after && after();
      };
      panel.addEventListener('transitionend', onEnd);
      this.dialog.classList.add('is-closing');
    }
  }

  if (!customElements.get('enquiry-dialog')) {
    customElements.define('enquiry-dialog', EnquiryDialog);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');
      this.counter = this.querySelector('[data-gallery-counter]');
      this.zoomTriggers = Array.from(this.querySelectorAll('[data-gallery-zoom-trigger]'));
      this.zoomDialog = this.querySelector('[data-gallery-zoom]');
      this.zoomImage = this.querySelector('[data-gallery-zoom-image]');
      this.zoomClose = this.querySelector('[data-gallery-zoom-close]');
      this.index = 0;

      this.zoomTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.openZoom(trigger));
      });
      this.zoomClose && this.zoomClose.addEventListener('click', () => this.zoomDialog.close());

      if (this.slides.length <= 1) return;

      this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.index - 1);
        if (event.key === 'ArrowRight') this.go(this.index + 1);
      });
    }

    go(index) {
      const total = this.slides.length;
      this.index = (index + total) % total;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
      if (this.counter) this.counter.textContent = `${this.index + 1} / ${total}`;
    }

    openZoom(trigger) {
      if (!this.zoomDialog || !this.zoomImage) return;
      this.zoomImage.src = trigger.dataset.fullSrc;
      this.zoomImage.alt = trigger.dataset.alt || '';
      this.zoomDialog.showModal();
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["story-chapter-gallery"] && !Shopify.designMode) return;
  try {
    class StoryChapterGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-story-track]');
      this.slides = Array.from(this.querySelectorAll('[data-story-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-story-dot]'));
      this.prevBtn = this.querySelector('[data-story-prev]');
      this.nextBtn = this.querySelector('[data-story-next]');
      this.index = 0;
      this.autoplaySpeed = 5000;
      this.timer = null;

      if (this.slides.length <= 1) return;

      this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.maybeStart());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.maybeStart());

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.maybeStart();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(index) {
      const total = this.slides.length;
      this.index = (index + total) % total;
      this.track.style.transform = 'translateX(-' + (this.index * (100 / total)) + '%)';
      this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true'));
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
    }

    maybeStart() {
      if (this.reducedMotion || this.slides.length <= 1) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), this.autoplaySpeed);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('story-chapter-gallery')) {
    customElements.define('story-chapter-gallery', StoryChapterGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
